module.exports = __webpack_public_path__ + "main/images/shared/google-play-badge.cd2d58262632de4c42f7054779bf3f9d.svg";